import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorService } from "../../../services/api/vendor.service";
import { VendorActions } from "../../actions/vendor.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorUserResendEmailEffects {
	put = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.resendEmail.resendEmail),
			switchMap((action) =>
				this.vendorService.resendInviteEmail(action.userIds).pipe(
					map(
						(stats) => VendorActions.resendEmail.resendEmailSuccess(),
						catchError((error) =>
							of(VendorActions.resendEmail.resendEmailFail(new FailState(error)))
						)
					)
				)
			)
		)
	);

	constructor(
		private vendorService: VendorService,
		private actions: Actions
	) {}
}
